import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionLayoutModel} from '../../models/promotion-layout.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PromotionLayoutService extends IService<PromotionLayoutModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'layout')
  }

  get(id): Observable<PromotionLayoutModel> {
    return super.get(id).pipe(
      map((result) => {
        /*conversione*/
        this.parseFromCharToBoolean(result);
        /*ordinamento*/
        result.details.sort((obj1, obj2) => {
          return obj1.row_num - obj2.row_num
        });
        return result
      })
    );
  }

  create(model: PromotionLayoutModel): Observable<PromotionLayoutModel> {
    console.log('create');
    this.parseFromBooleanToChar(model);
    return super.create(model);
  }

  update(model: PromotionLayoutModel): Observable<PromotionLayoutModel> {
    console.log('update');
    this.parseFromBooleanToChar(model);
    return super.update(model);
  }

  parseFromCharToBoolean(item: any) {
    if (item.flg_graph !== null && item.flg_graph !== undefined) {
      item.flg_graph = item.flg_graph === '1';
    }
    if (item.details && item.details.length > 0) {
      for (let elem of item.details) {
        elem.flg_graph = elem.flg_graph === '1';
      }
    }
  }

  parseFromBooleanToChar(item: any) {
    if (item.flg_graph !== null && item.flg_graph !== undefined) {
      item.flg_graph = item.flg_graph === true ? '1' : '0';
    }
    if (item.details && item.details.length > 0) {
      for (let elem of item.details) {
        elem.flg_graph = elem.flg_graph === true ? '1' : '0';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-layout.service.ts